module.exports = __webpack_public_path__ + "img/logo-datacoress.60542102.png";